<template>
  <section class="section">
    <div class="container">
      <div class="tabs">
        <ul>
          <router-link tag="li" :to="{ name: 'configurations.empresa' }">
            <a><small>Empresa</small></a>
          </router-link>
        </ul>
        <ul>
          <router-link tag="li" :to="{ name: 'configurations.account' }">
            <a><small>Cuentas</small></a>
          </router-link>
        </ul>
        <ul>
          <router-link tag="li" :to="{ name: 'configurations.terceros' }">
            <a><small>Terceros</small></a>
          </router-link>
        </ul>
        <ul>
          <router-link tag="li" :to="{ name: 'configurations.document' }">
            <a><small>Documentos</small></a>
          </router-link>
        </ul>
        <ul>
          <router-link tag="li" :to="{ name: 'configurations.costcenter' }">
            <a><small>C de costos</small></a>
          </router-link>
        </ul>
        <!-- <ul>
          <router-link tag="li" :to="{ name: 'configurations.months'}">
            <a>Meses</a>
          </router-link>
        </ul> -->
        <ul>
          <router-link
            tag="li"
            :to="{ name: 'configurations.commercialmonth' }"
          >
            <a><small>Mes</small></a>
          </router-link>
        </ul>
        <ul>
          <router-link tag="li" :to="{ name: 'configurations.inventorygroup' }">
            <a><small>G inventario</small></a>
          </router-link>
        </ul>
        <ul>
          <router-link tag="li" :to="{ name: 'configurations.cellar' }">
            <a><small>Bodegas</small></a>
          </router-link>
        </ul>
        <ul>
          <router-link
            tag="li"
            :to="{ name: 'configurations.measurementunits' }"
          >
            <a><small>U medida</small></a>
          </router-link>
        </ul>

        <ul>
          <router-link tag="li" :to="{ name: 'configurations.seller' }">
            <a><small>Vendedor</small> </a>
          </router-link>
        </ul>

        <ul>
          <router-link
            tag="li"
            :to="{ name: 'configurations.accountinglines' }"
          >
            <a><small>Linea</small></a>
          </router-link>
        </ul>
        <ul>
          <router-link tag="li" :to="{ name: 'configurations.products' }">
            <a><small>Producto</small> </a>
          </router-link>
        </ul>
      </div>
      <div v-if="isinicial">
        <div class="notification">
          <h1 class="title is-4">Configuración</h1>
          <h2 class="subtitle is-6">Configuraciones del sistema</h2>
          <p>
            Hacinedo clic en alguna de las opciones de arriba podrá configurar
            las diferentes opciones del sistema. Como empresa, documentos,
            cuentas, terceros. etc.
          </p>
        </div>
      </div>

      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      routeaqui: null,
    };
  },
  computed: {
    isinicial() {
      return this.$route.name === "configurations";
    },
  },
  created() {
    this.routeaqui = this.$route.name;
  },
};
</script>

<style lang="scss" scoped>
.tabs li.router-link-exact-active a {
  border-bottom-color: #3273dc;
  color: #3273dc;
}
</style>


// WEBPACK FOOTER //
// src/components/configurations/Configurations.vue